import { authApiCall } from '../auth/saga';

export const getBusinessReferralProgram = () =>
  authApiCall({
    url: '/users/business-referral-program/',
    method: 'get',
  });
